export default {
  namespaced: true,
  state: {
    valid: false,
    moneySheet: "money",
    date: {
      date: new Date(new Date().setHours(12, 59, 0, 0))
        .toISOString()
        .substr(0, 10),
      menu: false,
    },
    spendCategory: {
      rules: [(v) => !!v || "Spend Category is required"],
      selected: "",
      items: [],
    },
    vendor: {
      rules: [(v) => !!v || "Vendor is required"],
      selected: "",
      items: [],
    },
    amount: {
      rules: [(v) => !!v || "Amount is required"],
      value: "",
    },
    description: "",
    tags: "",
    transactionType: {
      rules: [(v) => !!v || "Transaction Type is required"],
      selected: "spend",
    },
    paySource: {
      rules: [(v) => !!v || "Pay Source is required"],
      selected: "chaseFreedom",
    },
    payMethod: {
      rules: [(v) => !!v || "Pay Method is required"],
      selected: "in person",
    },
    receipt: "pic",
    trip: "home",
    paySink: "",
    taxCategory: "",
    business: false,
    snackbar: {
      model: false,
      text: "Test",
      color: "secondary",
      timeout: 4000,
    },
  },
  getters: {},
  mutations: {
    UPDATE_MONEY_STATE: (state, payload) => {
      if (payload.field && payload.subfield) {
        state[payload.state][payload.field][payload.subfield] = payload.value;
      } else if (payload.field) {
        state[payload.state][payload.field] = payload.value;
      } else {
        state[payload.state] = payload.value;
      }
    },
  },
  actions: {
    updateMoneyState: ({ commit }, payload) => {
      commit("UPDATE_MONEY_STATE", payload);
    },
  },
};
